import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import { HealthcareTeamMember, isRegisteredHealthcareTeamMember } from "@domain/healthcare-team/healthcare-team";

export const sendAnalyticsEventOpenInvitation = (patient: { analyticsId: string }): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "openInvitation",
		params: [patient.analyticsId],
	});

export const sendAnalyticsEventAcceptInvitation = (patient: { analyticsId: string }): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "acceptInvitation",
		params: [patient.analyticsId],
	});

export const sendAnalyticsEventCancelInvitation = (patient: { analyticsId: string }): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "cancelInvitation",
		params: [patient.analyticsId],
	});

export const sendAnalyticsEventStartInvite = (patient: { analyticsId: string }): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "startInvite",
		params: [patient.analyticsId],
	});

export const sendAnalyticsEventResendInvitation = (
	patient: { analyticsId: string },
	invitedPt: HealthcareTeamMember,
): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "resendInvitation",
		params: [
			patient.analyticsId,
			isRegisteredHealthcareTeamMember(invitedPt) ? invitedPt.ptAnalyticsId : "",
			isRegisteredHealthcareTeamMember(invitedPt) ? "registered" : "unregistered",
		],
	});

export const sendAnalyticsEventDeleteColleague = (
	patient: { analyticsId: string },
	invitedPt: HealthcareTeamMember,
): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "deleteColleague",
		params: [patient.analyticsId, isRegisteredHealthcareTeamMember(invitedPt) ? invitedPt.ptAnalyticsId : ""],
	});

export const sendAnalyticsEventInviteRegisteredColleague = (
	patient: { analyticsId: string },
	invitedPt: { analyticsId: string },
	withMessage: boolean,
): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "inviteRegisteredColleague",
		params: [patient.analyticsId, invitedPt.analyticsId, withMessage ? "withMessage" : "withoutMessage"],
	});

export const sendAnalyticsEventInviteColleagueError = (patient: { analyticsId: string }): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "inviteColleagueError",
		params: [patient.analyticsId],
	});

export const sendAnalyticsEventInviteUnregisteredColleague = (
	patient: { analyticsId: string },
	method: "copyCTA" | "sendByEmailCTA",
): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "inviteUnregisteredColleague",
		params: [patient.analyticsId, method],
	});

export const sendAnalyticsEventClickCtaLeaveHct = (): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "clickCtaLeaveHct",
	});

export const sendAnalyticsEventHctLeft = (): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.HEALTHCARE,
		action: "hctLeft",
	});
